module.exports = __webpack_public_path__ + "img/prometheus.531b48d3.svg";